<template>
  <div class="collect-main">
    <span class="collect-main-title">收藏：</span>
    <span v-if="isCollect" @click="change">
      <svg-icon iconClass='sel-collect' className='sel-collect'></svg-icon>
    </span>
    <span v-else @click="change">
      <svg-icon iconClass='no-collect' className='no-collect'></svg-icon>
    </span>
  </div>
</template>
<script>
import Vue from 'vue'
import {request} from '../untils/request'
import {Dialog, Toast} from 'vant'

Vue.use(Toast)
export default {
  name: 'collect',
  data () {
    return {
      isCollect: false,
      params: {
        userId: this.$store.state.uid,
        resourceId: this.resource.resourceId,
        module: this.resource.module,
        title: this.resource.title
      }
    }
  },
  props: {
    resource:{
      type: Object
    }
  },
  watch:{
    resource(newVal,oldVal) {
      this.params = {
        // userId: this.$store.state.uid,
        resourceId: newVal.resourceId,
        module: newVal.module,
        title: newVal.title
      }
      this.collect()
    }
  },
  created () {
    this.collect ()
  },
  methods: {
    change () {
      if(this.isCollect===true){
        request('post', '/nlc-web/api/collect/removeCollect', this.params).then(res => {
          console.log('取消收藏结果', res)
          if (res.code===200 && res.data === "success") {
            Toast.success('取消收藏成功');
            this.isCollect = false
          } else if(res.code===1004) {
            this.showDialog()
          } else {
            Toast.fail('取消收藏失败');
          }
        })
      } else {
        request('post', '/nlc-web/api/collect', this.params).then(res => {
          console.log('收藏结果', res)
          if (res.code===200 && res.data === "success") {
            Toast.success('收藏成功')
            this.isCollect = true
          } else if(res.code===1004) {
            this.showDialog()
          } else {
            Toast.fail('收藏失败')
          }
        })
      }
    },
    // 判断是否收藏
    collect () {
      if(this.params.userId !==''){
        request('get', '/nlc-web/api/collect/resIsCollect', this.params).then(res => {
          console.log('是否收藏', res)
          if (res.code===200) {
            this.isCollect = res.data
          }
        })
      }
    },
    showDialog() {
      Dialog.confirm({
        message: '请您登录后收藏',
      }).then(() => {
        let url = encodeURI(window.location.href)
        window.location.href = process.env.API_ROOT + '/nlc-api/api/nlc/login?paramUrl='+url
      }).catch(() => {
        // on cancel
      })
    }
  }
}
</script>

<style scoped>
.collect-main{
  font-size: .38rem;
  font-family: SourceHanSansCN-Ligh;
  color: #444649;
  margin-left:.42rem;
}
.collect-main-title{
  font-size:.24rem;
  font-family: SourceHanSerifCN-Regular;
}
svg{
  vertical-align: middle !important;
}
.sel-collect{
  margin-right:.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/collect.vue